import { Injectable, inject } from "@angular/core";
import { AbstractControl, ValidationErrors } from "@angular/forms";
import { AsyncValidator, registerAsyncValidatorDecorator } from "@recursyve/ngx-form-generator";
import { Observable, of, timer } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { ApiService } from "../../../../../../api/api.service";

export function NewsTitleIsUnique() {
    return registerAsyncValidatorDecorator({
        name: "NewsTitleIsUniqueValidator"
    });
}

@Injectable()
export class NewsTitleIsUniqueValidator extends AsyncValidator {
    private readonly apiService = inject(ApiService);

    public readonly name = "NewsTitleIsUniqueValidator";

    public validate(control: AbstractControl): Observable<ValidationErrors | null> {
        if (!control.value || control.value === "") {
            return of(null);
        }

        return timer(200).pipe(
            switchMap(() =>
                this.apiService.news.titleAlreadyUsed(control.value).pipe(
                    map((isNewsTitleValid) => {
                        if (!isNewsTitleValid) {
                            control.markAsTouched();
                            return {
                                news_title_already_used: true
                            };
                        }
                        return null;
                    })
                )
            )
        );
    }
}
